var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.73 60.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #0d5227;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2.23px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e8f3e8;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.73,40.69c0,11.1-8.99,20.09-20.09,20.09H17.5c-3.08,0-5.58-2.5-5.58-5.58V17.25c0-6.16,5-11.16,11.16-11.16H62.15c3.08,0,5.58,2.5,5.58,5.58v29.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.43,2.12l4.86,11.59c.12,.28,.31,.52,.56,.7,.25,.18,.54,.29,.84,.32l12.44,1.08c.33,.03,.65,.15,.9,.36,.26,.21,.45,.48,.55,.8,.1,.32,.11,.65,.02,.97-.09,.32-.27,.6-.53,.82l-9.44,8.24c-.23,.2-.4,.46-.49,.75-.09,.29-.11,.6-.04,.9l2.83,12.25c.07,.32,.05,.65-.06,.96-.11,.31-.32,.58-.58,.77-.27,.19-.58,.31-.91,.32-.33,.02-.65-.07-.94-.23l-10.69-6.49c-.26-.16-.56-.24-.86-.24s-.6,.08-.86,.24l-10.69,6.49c-.28,.17-.61,.25-.94,.23-.33-.02-.64-.13-.91-.32s-.47-.46-.58-.77c-.11-.31-.14-.64-.06-.96l2.83-12.25c.07-.3,.06-.61-.04-.9-.09-.29-.26-.55-.49-.75L1.71,18.75c-.25-.21-.44-.5-.53-.82s-.08-.66,.02-.97c.1-.32,.29-.59,.55-.8,.26-.21,.57-.33,.9-.36l12.44-1.08c.3-.03,.59-.14,.84-.32,.25-.18,.44-.42,.56-.7L21.36,2.12c.13-.3,.34-.55,.62-.73,.27-.18,.59-.27,.92-.27s.65,.1,.92,.27c.27,.18,.49,.43,.62,.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.176cf1d7b5866feeac1e5e556653ef90.svg";
export { ForwardRef as ReactComponent };